module.cC({
    name: 'StudentEnrollmentController',
    inject: ['$scope', '$timeout', 'durations', 'enrollment', 'participant',
             'ModelService'],
    data: {
        'enrollment': 'enrollment',
        'durations': 'durations',
        'participant': 'participant',
        'forms': '{}',
    },

    listen: {
        duration_of_stay: {
            update: "updateDurations",
            delete: "updateDurations",
            create: "updateDurations",
        }
    },

    computed: {
        openForm: function() {
            for (var name in this.forms) {
                if (this.forms[name].isOpen) {
                    return true;
                }
            }
            return false;
        }
    },

    methods: {
        updateDurations: function(id, owner_id) {
            if (owner_id === this.enrollment.id) {
                this.$timeout.cancel(this.refreshTimeout);
                this.refreshTimeout = this.$timeout(this._updateDurations);
            }
        },

        _updateDurations: function() {
            this.ModelService.getModelRelation(this.enrollment, 'durations')
                .then(this._replaceDurations);
        },

        _replaceDurations: function(durations) {
            angular.copy(durations, this.$.durations)
        }
    }
});
